import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaDateLabelComponent} from './la-date-label.component';
import {LaTextModule} from '../text/la-text.module';

export {LaDateLabelComponent} from './la-date-label.component';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
    LaTextModule.forRoot()
  ],
  exports: [LaDateLabelComponent],
  declarations: [LaDateLabelComponent]
})
export class LaDateLabelModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaDateLabelModule,
      providers: []
    };
  }
}
